export class Controller {

    /** @ngInject */
    constructor($translate) {
        this.$translate = $translate;
    }

    $onInit() {
    }

    templateUrl() {
        return require(`./info-sharing-center-${this.$translate.use()}.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/info-sharing-center/info-sharing-center.controller.js